const regexes = require('./regexes')

// ? ******************************************************************************************
// ? ******************************************************************************************

/**
 * @param {string} type
 * @param {string|null} country
 * @returns {*}
 */
function getRegex ({ type, country = null } = {}) {
  if (!type) return
  return regexes?.[type]?.(country)?.source
}

module.exports = { getRegex }
